
import { FC } from "react";
import { useApp } from "../../../context/useApp";
import { Fieldset } from "../../../parts/inputs/Fieldset";
import { DEFAULT_DIALOG_HANDLE, MIN_AVAILABILITY_PERCENT_TO_DISPLAY_FIRE_ICON_IN_ZONES, SCREEN_BREAKPOINT_2, UNASIGNED_ZONES, CHILDREN_PER_ADULT, ZONE_ORDERS } from "../../../utils/symbols";
import { _, getZoneName, parseNum } from "../../../utils/helpers";
import { Icon } from "../../../parts/Icon";
import { DialogHandle, SafeZone, TranslationKey, ProductCategory } from "../../../types";
import { useRef} from "react";

export const Zones: FC = () => {

    const {
        state: { tableMapHandle, booking, screen, dialogHandles, products, priceRules },
    } = useApp()

    const zonesList = useRef<HTMLDivElement>(null)

    const dialogHandle:DialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    const sortedTickets = products.filter(product => {

        if (product.type !== 'ticket' || !product.zone) return false
        if (product.name === 'Entrada Residente') return false

        return true
    }).sort((a, b) => {

        // const a_availability = tableMapHandle.getEventOccupation(a.zone as SafeZone).percentAvailable
        // const b_availability = tableMapHandle.getEventOccupation(b.zone as SafeZone).percentAvailable
        // if (a_availability > 0 && b_availability === 0) return -1
        // if (b_availability > 0 && a_availability === 0) return 1
        
        // return b.price - a.price
        return ZONE_ORDERS[a.zone as SafeZone] - ZONE_ORDERS[b.zone as SafeZone]
    })

    const handleFocusZone = (zone: SafeZone | 'cv', category: ProductCategory = 'adult') => {

        // changed: remove the zoom when selecting a zone
        // if (tableMapHandle.getCurrentlyFocusing() === zone) tableMapHandle.focusRect()
        // else tableMapHandle.focusRect({rect: zone})
        if (tableMapHandle.getCurrentlyFocusing() === zone) tableMapHandle.focusRect()
        else tableMapHandle.focusRect({rect: 'cv', dataFocusing: zone})

        if (zone !== 'cv' && UNASIGNED_ZONES.includes(zone)) {
            dialogHandle.openDialog({
                dialog: 'unassigned-seats',
                zone: zone,
                category,
                className: 'unassigned-seats w-100 h-100 df aic jcc'
            })
        }
    }
    
    const handleZoneInfo = (zone: SafeZone) => {

        tableMapHandle.focusRect({rect: zone})
        const description = `3zo_${zone}____${booking.venueId}` as TranslationKey
        const src = `https://cardamomo.ams3.cdn.digitaloceanspaces.com/bookings/resources/img/${zone}-${booking.venueId}.png`

        dialogHandle.openDialog({
            dialog: 'zone',
            zone: zone,
            alt: '',
            src: src,
            description: _(description),
            className: 'zone w-100 h-100 df aic jcc'
        })
    }

    const handleAddChildrensTicketClick = () => {
        // dialogHandle.openDialog({
        //     dialog: 'add-children',
        //     className: 'add-children w-100 h-100 df aic jcc',
        // })
        try {
            tableMapHandle.selectAdjacentChildrenSeat()
        } catch (err) {
            console.error(err)
            dialogHandle.openDialog({
                dialog: 'error', 
                icon: 'children',
                className: 'error w-100 h-100 df aic jcc adjacent-seat-not-found',
                title: _('3zo_child_a'), 
                message: _('3zo_there__'),
                closeButton: true
            })
        }
    }

    return (
        <Fieldset 
            id="tickets-selection" 
            className="zones mt-7"
        >
        <div 
            className="w-100" 
            ref={zonesList}
            aria-hidden
        >
        {sortedTickets.map(ticket => {


            
            const zone = ticket.zone as SafeZone
            const availability = tableMapHandle.getEventOccupation(zone).percentAvailable
            const zoneName = getZoneName('long', zone, booking.journey)
            const parsedFinalPrice = parseNum('EUR', ticket.price)
            const qty = booking.getTickets({zone, category: ticket.category}).reduce((total, ticket) => total += ticket.qty, 0)
            const displayFireIcon = availability <= MIN_AVAILABILITY_PERCENT_TO_DISPLAY_FIRE_ICON_IN_ZONES && availability > 0
            const ariaLabel = `${zoneName} ${parsedFinalPrice}.`

            if (ticket.category === 'children' && qty === 0) return null

            return (
            <button
                key={ticket.id} 
                role="option"
                aria-label={ariaLabel}
                className={`zone jcsb df p-7 fd-c w-100 zone-${zone} r3 mb-6 p-r ${qty > 0 ? 'selected' : ''} ${availability === 0 ? 'disabled' : ''} button b-0 outline-shadow`}
                onClick={(event) => {
                    if (availability === 0) return
                    event.currentTarget.blur()
                    handleFocusZone(zone, ticket.category)
                }}
            >   
                <div className="df aic jcsb w-100" aria-hidden>
                    <div className="text s20-600 w-100 df aic jcfs name cap" aria-hidden>
                        <p className="mr-4" aria-hidden>{`${qty > 0 ? qty +'x' : ''} ${zoneName}`}</p>
                        {ticket.category === 'children' && (<Icon icon={'children'} className="mr-3"/>)}
                        {/* <span 
                            aria-hidden
                            className="info-button button b-0 p-0" 
                            onClick={(event) => {
                                event.stopPropagation()
                                handleZoneInfo(zone)
                        }}>
                            <Icon icon="info"/>
                        </span> */}
                    </div>

                    {screen.width < SCREEN_BREAKPOINT_2 && displayFireIcon ? (
                        <Icon icon="fire" className="icon-group r2 mr-12"/>
                    ) : screen.width < SCREEN_BREAKPOINT_2 && availability === 0 ? (
                        <Icon icon="no-tickets" className="icon-group sold-out r2 mr-12"/>
                    ) : null }

                    <p className="text s20-600 price" aria-hidden>
                        {   ticket.discounts.length > 0  && 
                            <span className="text softer strikethrough mr-4 s18-500">
                                {parseNum('EUR', ticket.originalPrice)}       
                            </span>
                        }
                        {parsedFinalPrice}
                    </p>
                </div>

                {screen.width >= SCREEN_BREAKPOINT_2 && displayFireIcon ? (
                    <div className="df aic mt-7 w-fc icon-group px-5 py-3 r2" aria-hidden>
                        <p className="text s14-500 df" aria-hidden><Icon icon="fire"/><span>{_('0ge_onlya__')}</span></p>
                    </div>
                ) : screen.width >= SCREEN_BREAKPOINT_2 && availability === 0 ? (
                    <div className="df aic mt-7 w-fc icon-group sold-out px-5 py-3 r2" aria-hidden>
                        <p className="text s14-500 df" aria-hidden><Icon icon="no-tickets"/><span>{_('1da_soldo__')}</span></p>
                    </div>
                ) : null }
                
            </button>
        )})}
        </div>
        <div className="df aic jcsb child-tickets-container">
            <button
                className="button b-0 df aic text s20-500 pl-2 add-children outline-shadow r3" 
                onClick={handleAddChildrensTicketClick}
            >
                <Icon icon={'plus'} className="mr-0" style={{scale: '0.8'}} aria-hidden/>
                <Icon icon={'children'} className="mr-4 ml-3" aria-hidden/>
                {_('3zo_child__')}
            </button>
            <span className="tooltip-container">
                <Icon icon="info"/>
                <span className="tooltip bl text s14-400">{_('3zo_uptoy__')}</span>
            </span>
        </div>
        </Fieldset>
    )
}